import config from './config'
export const {CONFIG: {TIMEZONE = 'UTC', locale = 'en-us'}} = config
export const {DateTime, Settings, Duration, Interval} = require('luxon')
Settings.defaultLocale = locale
Settings.defaultZoneName = TIMEZONE

export const now = DateTime.local().setZone(TIMEZONE)
export const dateReset = { hour: 0, minute: 0, second: 0 }
export const dateEndReset = { hour: 23, minute: 59, second: 59 }

export const todayStart = now.set(dateReset)
export const todayEnd = now.set(dateEndReset)
export const tomorrowStart = todayStart.plus({days: 1})
export const tomorrowEnd = todayEnd.plus({days: 1})

export const parseDateTime = date => {

  if (!date) {
    return date
  }
  if (date === 'today' || date === 'today-start') {
    return todayStart
  }
  if (date === 'today-end') {
    return todayEnd
  }
  if (date === 'now') {
    return now
  }
  if (date === 'tomorrow' || date === 'tomorrow-start') {
    return tomorrowStart
  }
  if (date === 'tomorrow-end') {
    return tomorrowEnd
  }

  if (!(date instanceof DateTime)) {
    if (/\s/.test(date)) {
      return DateTime.fromSQL(date)
    }
    else if (/-/.test(date)) {
      return DateTime.fromISO(date)
    }
    else if (!/\D/.test(date)) {
      return DateTime.fromMillis(1 * date)
    }
    else if (/\//.test(date)) {
      return DateTime.fromJSDate(new Date(date))
    }
    else if (_.isString(date)) {
      return DateTime.fromJSDate(new Date(date))
    }
    else if (date instanceof Date) {
      return DateTime.fromJSDate(date)
    }
    else if (_.isObject(date)) {
      return DateTime.fromObject(date)
    }
  }
  return date
}

export const formatDate = (date, format, prefix = '', suffix = '') => {
  const datetime = parseDateTime(date).setLocale('en-US')
  if (datetime.isValid) {
    format = format || 'DDD'
    return prefix + datetime.toFormat(format) + suffix
  }

  return ''
}

/**
 *
 * @param date
 * @param template
 * @returns luxon.DateTimeInterval
 */
export const parseDateInterval = (date, template)  => {

  if (!template) {
    return null
  }

  let startDate = now
  let dates = startDate.until(todayEnd)

  if (date instanceof DateTime && template instanceof DateTime) {
    return startDate.until(template)
  }

  if (template instanceof DateTime) {
    date = parseDateTime(date)
    return date.until(template)
  }

  if (template === 'custom') {
    startDate = parseDateTime(date)// @todo: change to fromFormat
    return startDate.until(startDate.set(dateEndReset))
  }
  if (template === 'tomorrow') {
    startDate = tomorrowStart
    return startDate.until(tomorrowEnd)
  }
  if (template === 'this-week') {
    return now.until(now.endOf('week').set(dateEndReset))
  }
  if (template === 'this-month') {
    return now.until(now.endOf('month').set(dateEndReset))
  }

  return dates
}

export const getDate = (date, prefix = '', suffix = '') => {
  return formatDate(date, 'DDD', prefix, suffix)
}
export const getDayDate = (date, prefix = '', suffix = '') => {
  return formatDate(date, 'd MMMM, EEEE', prefix, suffix)
}
export const getDayDateYear = (date, prefix = '', suffix = '') => {
  return formatDate(date, 'DDDD', prefix, suffix)
}
export const getDateTime = (date, prefix = '', suffix = '') => {
  return formatDate(date, 'DDD', prefix, suffix)
}
export const getDateTimeYear = (date, prefix = '', suffix = '') => {
  return formatDate(date, 'DDD', prefix, suffix)
}

export const getNow = (zone = TIMEZONE, seconds = false) => {
   const nowDate = DateTime.local().setZone(zone)
    if (seconds) {
      return nowDate.toSeconds()
    }
    return nowDate
}

export const getNowSeconds = (zone = TIMEZONE) => getNow(zone, true)

export const time2Min = (time) => {
  return DateTime.fromFormat(time, 'h:mm a').valueOf()/60000
}

Vue.prototype.$$now = now
Vue.prototype.$$getNow = getNow
Vue.prototype.$$parseDateTime = parseDateTime
Vue.prototype.$$TIMEZONE = TIMEZONE
Vue.prototype.$$formatDate = formatDate

export default {
  TIMEZONE,
  DateTime,
  Duration,
  Interval,
  Settings,
  now,
  dateReset,
  dateEndReset,
  todayStart,
  todayEnd,
  tomorrowStart,
  tomorrowEnd,
  parseDateTime,
  formatDate,
  parseDateInterval,
  getDate,
  getDayDate,
  getDayDateYear,
  getDateTime,
  getDateTimeYear,
  getNow,
  getNowSeconds,
  time2Min,
}
